import { getUser } from '../../../Features/FeatureGlobal';

export function DtoPersonalData() {
    return{
        idDatosPersonales: "",
        nombres: "",
        apellidoPaterno: "",
        apellidoMaterno: "",
        dicTipoDocumento: "",
        identificacion: "",
        idPlantillaAplicada: "",
        correoElectronico: "",
        telefonoCelular: "",
        dicDepartamento: "",
        dicCiudadResidencia: "",
        dicProfesion: "",
        fechaNacimiento: "",
        genero: "",
        salary: "",
        pais: "",
        paisesTrabajar: [],
        direccionResidencia: "",
        descripcionPerfilProfesional: "",
        anosExperiencia: "",
        idiomaNivel: "",
        rutaFoto: "",
        redesSociales: "",
        dicAspiracionSalarial: "",
        movilidadLaboral: "",
        pdfHojaDeVida: "",
        colorHV: "",
        tipoTextoHV: "",
        habilidades: [],
    }
}

export function DtoFormEducation() {
    return {
        institucionEducativa: "",
        dicNivelEducativo: "",
        tituloObtenido: "",
        dicAreaEstudio: "",
        estadoEstudio: "",
        dicCiudadEstudio: "",
        fechaInicio: "",
        fechaFin: "",
        idUsuario: getUser().idUsuario,
        idDatosPersonales: "",
        dicIntensidadEstudio: "",
        dicTipoEstudio: "",
        otroEstudio: "",
        esComplementario: false,
        dicPaisExtranjero: "",
        descripcionEducacion: "",
        idInformacionEducativa: 0,
    };
}

export function DtoFormEducationComplementary() {
    return {
        institucionEducativa: "",
        dicNivelEducativo: "",
        tituloObtenido: "",
        dicAreaEstudio: "",
        estadoEstudio: "",
        dicCiudadEstudio: "",
        fechaInicio: "",
        fechaFin: "",
        idDatosPersonales: "",
        idUsuario: getUser().idUsuario,
        dicIntensidadEstudio: "",
        dicTipoEstudio: "",
        otroEstudio: "",
        esComplementario: true,
        dicPaisExtranjero: "",
        descripcionEducacion: "",
        idInformacionEducativa: 0,
    };
}

export function DtoFormWorkingInfomation() {
    return {
        empresa: "",
        cargo: "",
        funcioneslogros: "",
        fechaIngreso: "",
        fechaSalida: "",
        trabajoActualmente: "",
        idDatosPersonales: "",
        idExperienciaLaboral: 0,
    };
}

export function DtoCurriculumFile() {
    return {
        idUsuario: getUser().idUsuario,
        imagenBase64: "",
        tipoArchivo: "",
        idImagen: "",
        formatoImg: "",
    };
}

export function DtoFormLanguage() {
    return {
        id: '',
        nivel: '',
    }
}

export function DtoSocialNetwork() {
    return {  
        facebook: "",
        linkedin: "",
        otro: "",
        instagram: "",
    };
}

export function DtoSocialNetworks() {
    return [
        {
            id: 1,
            tipoConctacto: "Linkedin",
            contacto: "",
            background: "rgb(216, 216, 216)",
            name: "linkedin",
        },
        {
            id: 2,
            tipoConctacto: "Facebook",
            contacto: "",
            background: "rgb(23, 121, 199)",
            name: "facebook",
        },
        {
            id: 3,
            tipoConctacto: "Portafolio o blog",
            contacto: "",
            background: "rgb(102, 209, 126)",
            name: "otro",
        },
        {
            id: 4,
            tipoConctacto: "Instagram",
            contacto: "",
            background: "rgb(216, 216, 216,0)",
            name: "instagram",
        },
    ];
}